<template>
  <section class="navbar-container">
    <h1 class="logo-wrapper">
      <img
        class="logo logo--main"
        :src="require('@/assets/images/logo-white.svg')"
      />
    </h1>
    <div class="othrt-link">
      <a
        v-scroll-to="{
          el: '#sectionBecomeGUGOBETsPartner',
          duration: 1000,
          easing: 'ease-in-out',
        }"
        href="#"
        title="Contact Us"
        class="othrt-link__contace-us fz-14"
        target="_blank"
        ><i class="my-icon icon-telegram fz-16"></i>Apply Now</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'Navbar',
};
</script>

<style lang="scss">
.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 60px;
  padding: 0 vw-dsk($page-margin-x);
  background-color: rgba(#000, 0.9);

  .logo-wrapper {
    display: flex;
    align-items: center;
  }

  .othrt-link {
    display: flex;
    align-items: center;
    &__recruitment,
    &__contace-us {
      display: flex;
      align-items: center;

      color: #fff;
      letter-spacing: 1px;
      line-height: 1.1;

      transition: 0.5s all;
      &:hover {
        color: var(--c-main-2);
      }
      .my-icon {
        height: 16px;
        margin-top: -5px;
        margin-right: 5px;
      }
    }
    &__separate {
      width: 2px;
      height: 20px;
      background-color: #979797;
      margin: 0 10px;
    }
  }

  .logo {
    &--main {
      height: 21px;
      margin-right: 10px;
      padding-right: 10px;
    }

    &--partner {
      height: 46px;
    }
  }

  @include mq(mbl) {
    height: 54px;
    padding: 0 vw-mbl($page-margin-x-mbl);

    .logo {
      &--main {
        height: 18px;
        margin-right: 8px;
        padding-right: 8px;
      }

      &--partner {
        height: 32px;
      }
    }
  }
  @include mq(mbp) {
    .logo-wrapper {
      margin-bottom: 10px;
      img.logo {
        padding: 0;
        margin: 0;
      }
    }
  }
}
</style>
